// extracted by mini-css-extract-plugin
export default {"fillAnimated":"AssessmentProgress_fillAnimated__URTP-","light":"AssessmentProgress_light__xGZ36"};